import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Package, ShoppingCart, Users, LogOut, Store } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, testid: "admin-nav-overview", end: true },
  { to: "/admin/products", label: "Products", icon: Package, testid: "admin-nav-products" },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart, testid: "admin-nav-orders" },
  { to: "/admin/customers", label: "Customers", icon: Users, testid: "admin-nav-customers" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-background" data-testid="admin-layout">
      <aside className="w-16 lg:w-60 shrink-0 border-r border-zinc-800 bg-zinc-950 flex flex-col">
        <Link to="/" className="h-16 flex items-center px-4 border-b border-zinc-800">
          <span className="font-display text-xl font-extrabold uppercase hidden lg:inline">laze<span className="text-brand">.</span></span>
          <span className="font-display text-xl font-extrabold uppercase lg:hidden">l<span className="text-brand">.</span></span>
        </Link>
        <nav className="flex-1 py-4 space-y-1 px-2">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md font-mono text-[11px] uppercase tracking-widest transition ${
                  isActive ? "bg-brand text-black" : "text-zinc-400 hover:text-white hover:bg-zinc-900"
                }`
              }
            >
              <n.icon className="h-4 w-4 shrink-0" />
              <span className="hidden lg:inline">{n.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-2 border-t border-zinc-800 space-y-1">
          <button onClick={() => navigate("/")} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md font-mono text-[11px] uppercase tracking-widest text-zinc-400 hover:text-white hover:bg-zinc-900 transition">
            <Store className="h-4 w-4 shrink-0" /><span className="hidden lg:inline">Storefront</span>
          </button>
          <button onClick={async () => { await logout(); navigate("/"); }} data-testid="admin-logout" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md font-mono text-[11px] uppercase tracking-widest text-red-400 hover:bg-zinc-900 transition">
            <LogOut className="h-4 w-4 shrink-0" /><span className="hidden lg:inline">Log out</span>
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <header className="h-16 border-b border-zinc-800 flex items-center justify-between px-6">
          <h1 className="font-display text-lg font-bold uppercase tracking-tight">Admin</h1>
          <span className="font-mono text-xs text-zinc-500 truncate">{user?.email}</span>
        </header>
        <div className="p-6"><Outlet /></div>
      </div>
    </div>
  );
}
